// extracted by mini-css-extract-plugin
export default {"navigationList":"NavigationList_navigationList__lrwaJ","item":"NavigationList_item__r9gQR","item_active":"NavigationList_item_active__YujIB"};